
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as TrainingSessionIconComponent } from "./training-session-icon.svg";

export const TrainingSessionIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <TrainingSessionIconComponent {...props} />;
};
